import React from 'react'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { propTypes } from 'react-bootstrap/esm/Image'

function Banner({ partnerDetails }) {
    return (
        <div className="w-100"
        style={{ backgroundImage: partnerDetails?.slug == 'usm' ? 'url(banner/usm-banner.jpg)' : 'url(banner/baner-top.jpg)', height: '300px', backgroundPosition: 'center center', backgroundSize: 'cover' }}>
        {/* style={{ backgroundImage: partnerDetails?.brand_setting?.customerbannerurl ? 'url('+partnerDetails.brand_setting.customerbannerurl+')' : 'url(banner/baner-top.jpg)', height: '300px', backgroundPosition: 'center center', backgroundSize: 'cover' }}> */}
        </div>
    )
}

Banner.propTypes = {
    partnerDetails: propTypes.object
}

Banner.defaulProps = {
    partnerDetails: EMPTY_OBJECT
}

export default Banner